export default "__VITE_ASSET__vMAP72dS__"